import React, { useContext, useEffect, useState } from 'react';

// Third-party.

// Helpers.
import Helper from '../../helpers/Helper';

// Types.
import Batch from '../../types/instance/Batch';
import Wait from '../../types/instance/Wait';
import { TimeRangeContext } from "../../context/TimeRangeContext";
import { buildApiQuery } from "../../helpers/timeRangeUtils";
import ActivityApi from "../../api/instance/ActivityApi";

function BatchBreakdown(props: { batch: Batch, waits: Wait[], instanceId: number, instanceTime?: number, maxWaitTime?: number, filterParameters: string }) {
    const [waits, setWaits] = useState<Wait[]>([]);
    const timeRangeContext = useContext(TimeRangeContext)

    // Calculate batchWeight for rendering
    let batchWeight: number = 0;

    if (props.maxWaitTime) {
        batchWeight = Math.floor((100 / props.maxWaitTime) * props.batch.waittime);
    } else if (props.instanceTime) {
        // Fallback to instanceTime if maxWaitTime is not provided
        batchWeight = Math.floor((100 / props.instanceTime) * props.batch.waittime);
    }

    useEffect(() => {

        const getBatchWaits = async () => {

            // Get the batch waits.
            ActivityApi.getWaitEvents(buildApiQuery(timeRangeContext.timeRange), props.instanceId, `&batchsqlhash=${props.batch.batchsqlhash}${props.filterParameters}`)
                .then(async (response: { data: Wait[]; }) => {

                    let batchWaits: Wait[] = response.data;

                    // Build top waits pie chart.
                    for (let index = 0; index < batchWaits.length; index++) {

                        // Look for a matching passed wait state.
                        let matchedWaits: Wait[] = props.waits.filter(wait => wait.waitevent === batchWaits[index].waitevent);

                        if (matchedWaits.length > 0) {

                            // Use the matched wait colour.
                            batchWaits[index].color = matchedWaits[0].color;
                        } else {

                            // Unmatched wait, so use the generic colour.
                            batchWaits[index].color = '#999';
                        }

                        // Work out the wait percentage.
                        const weight = Math.floor((100 / props.batch.waittime) * batchWaits[index].waittime);

                        // Set the batch weight and build the tooltip.
                        batchWaits[index].weight = weight;

                    }

                    setWaits(batchWaits);
                })
                .catch((error: any) => {
                    console.error('Failed to retrieve wait event for batch.', error);
                });
        }

        if (props.instanceTime) {
            getBatchWaits();
        }

    }, [props.batch.batchsqlhash, props.waits, props.instanceTime, timeRangeContext, props.instanceId, props.filterParameters]);

    if (batchWeight < 5) {
        return (
            <React.Fragment>-</React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div style={{ width: `${batchWeight}%` }} data-tooltip-id="global-tooltip" data-tooltip-html={`<p class="mb-2">This batch has the following top waits:</p><ol class="list-unstyled mb-0">${waits.filter(wait => wait.weight && wait.weight > 0).map(wait =>
                `<li class="d-flex justify-content-between align-items-center"><span>${wait.waitevent}:</span> <span class="ms-3 text-end">${Helper.getTimeInEnglish(wait.waittime)} (${wait.weight}%)</span></li>`
            ).join('')}</ol>`}>
                {waits.filter(wait => wait.weight && wait.weight > 0).map((wait: Wait, index) => (
                    <div key={index} style={{ width: `${wait.weight}%`, backgroundColor: wait.color }}>&nbsp;</div>
                ))}
            </div>
        </React.Fragment>
    );
}

export default BatchBreakdown;
